import { render, staticRenderFns } from "./ZapisiSpominaTemplate.vue?vue&type=template&id=4df2cd0c&"
import script from "./ZapisiSpominaTemplate.vue?vue&type=script&lang=js&"
export * from "./ZapisiSpominaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ZapisiSpominaTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports